import React, { Component, Fragment } from "react";

import PropTypes from "prop-types";
import { Grid, Button } from "@material-ui/core";

import { TextField } from "@material-ui/core";

import ClearIcon from "@material-ui/icons/Clear";

import { KeyboardTimePicker } from "@material-ui/pickers";

class ReportLine extends Component {
  handleTimeChange = (m) =>
    this.handleChange({ target: { name: "time", value: m } });

  handleChange = (e) => this.props.handleChangeOnLine(this.props.line.id, e);

  render() {
    return (
      <Fragment>
        <Grid item xs={2} sm={2}>
          <KeyboardTimePicker
            clearable
            format="HH:mm"
            id="time"
            name="time"
            label="Tijdstip *"
            value={this.props.line.time}
            onChange={this.handleTimeChange}
            fullWidth
            ampm={false}
          />
        </Grid>

        <Grid item xs={8} sm={8}>
          <TextField
            id="remarks"
            name="remarks"
            label="Rapportage"
            value={this.props.line.remarks}
            onChange={this.handleChange}
            multiline
            fullWidth
          />
        </Grid>

        <Grid item xs={2} sm={2}>
          <Button
            color="secondary"
            onClick={() => this.props.onClickDeleteLine(this.props.line.id)}
          >
            <ClearIcon />
          </Button>
        </Grid>
      </Fragment>
    );
  }
}

ReportLine.propTypes = {
  onClickDeleteLine: PropTypes.func.isRequired,
  handleChangeOnLine: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  line: PropTypes.shape({
    id: PropTypes.string,
    time: PropTypes.string,
    remarks: PropTypes.string,
  }),
};

export default ReportLine;



// WEBPACK FOOTER //
// ./src/components/ReportLine.js